// token.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.authService.getAccessToken();
    let authReq = req;
    if (accessToken) {
      authReq = this.addTokenHeader(req, accessToken);
    }
  
    return next.handle(authReq).pipe(
      catchError((error: any) => {
        // Check for HTTP error responses (401 Unauthorized)
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Check if the error indicates token expiration
          if (error.error && error.error.error && error.error.error.name === 'TokenExpiredError') {
            // Force sign out if token expired
            this.authService.signOut();
            this.router.navigate(['/auth/login']);
            return throwError(() => error);
          }
          // If not already refreshing, try refreshing the token
          if (!this.isRefreshing) {
            this.isRefreshing = true;
            return this.authService.refreshToken().pipe(
              switchMap((newToken) => {
                this.isRefreshing = false;
                return next.handle(this.addTokenHeader(req, newToken));
              }),
              catchError((refreshError) => {
                this.isRefreshing = false;
                // If refresh fails, sign out
                this.authService.signOut();
                this.router.navigate(['/auth/login']);
                return throwError(() => refreshError);
              })
            );
          } else {
            return throwError(() => error);
          }
        }
        return throwError(() => error);
      })
    );
  }

  private addTokenHeader(request: HttpRequest<any>, token: string): HttpRequest<any> {
    const lang = localStorage.getItem('lang') || 'ar';
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Accept-Language': lang
      }
    });
  }
}